import React, { useEffect, useRef } from 'react'

import { PageHeaderProps } from './PageHeader.types'
import Tab from '../Tabstrip/Tab'
import TabTitle from '../Tabstrip/TabTitle'
import Button from '../Button/Button'
import Tabstrip from '../Tabstrip/Tabstrip'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import ButtonGroup from '../ButtonGroup/ButtonGroup'
import useElSize from '../useElSize/useElSize'
import usePageContext from '../Page/usePageContext'

const PageHeader: React.FC<PageHeaderProps> = ({ children, title, actions = [], crumbs = [], tabs = [] }) => {
    const { setPageHeaderHeight } = usePageContext()
    const ref = useRef(null)
    const size = useElSize(ref)

    useEffect(() => {
        setPageHeaderHeight(size.height)
    }, [size])

    return (
        <div
            ref={ref}
            data-testid='PageHeader'
            className={`r-pageheader-container ${tabs.length > 0 ? 'r-pageheader-with-tabs' : ''}`}
        >
            {children || (
                <React.Fragment>
                    {crumbs.length > 0 ? (
                        <div className={'r-pageheader-crumb'}>
                            <Breadcrumb crumbs={crumbs} />
                        </div>
                    ) : (
                        ''
                    )}

                    <div className={'r-pageheader-title-container'}>
                        <div className={'r-pageheader-title'}>{title}</div>
                        {actions ? <div className={'r-pageheader-actions'}>{actions}</div> : null}
                    </div>
                    {tabs ? (
                        <div className={'r-pageheader-tabs'}>
                            <Tabstrip>{tabs}</Tabstrip>
                        </div>
                    ) : (
                        ''
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

export default PageHeader
